import useConfiguration from "hooks/useConfiguration"

export default function useRoutes() {
  const { hub } = useConfiguration()
  return hub.routes
}
